import { COLUMN_VISIBLE_TOGGLED } from './table-columns.action';

const addToDataLayer = data => window.dataLayer.push(data);

export const TableColmunsAnalytics = {
  [COLUMN_VISIBLE_TOGGLED]: action => addToDataLayer({
    event: 'columnVisibilityToggled',
    column: action.payload.label
  })
};
